/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { noop } from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

/**
 * @type {import('react').FC<ComponentAccordionBottomToggleProps>}
 */
const ComponentAccordionBottomToggle = (props) => {
    const { onClick = noop, show, direction } = props;
    
    if (!show) {
        return null;
    }

    return (
        <div
            className='simplicity-component-toggle'
            onClick={onClick}
        >
            <div className='simplicity-component-chevron-bar' >
                <hr className="horizontalLine" />
                {direction === "up" &&
                    <FontAwesomeIcon icon={"fa-regular fa-chevron-up"} />
                }
                {direction === "down" &&
                    <FontAwesomeIcon icon={"fa-regular fa-chevron-down"} />
                }
                <hr className="horizontalLine" />
            </div>
        </div>
    );
};

export { ComponentAccordionBottomToggle };


/**
 * @typedef {object} ComponentAccordionBottomToggleProps
 * @property {boolean} show
 * @property {'up' | 'down'} direction
 * @property {() => void=} onClick
 */
